export interface DealRequestAllocationRealEstate {
	guid?: string;
	requestAllocationGuid?: string;
	realEstateType?: ProfileRealEstateType;
	purchaseLandOnlyAmount?: number;
	purchaseLandAndImprovementsAmount?: number;
	purchaseLandImprovementsOnlyAmount?: number;
	constructBuildingAmount?: number;
	additionsToBuildingAmount?: number;
	renovationsToBuildingAmount?: number;
	payInterimConstructionLoanAmount?: number;
	purchaseBuildingAmount?: number;
	termLoanNeeds?: number;
	revolvingDebtNeeds?: number;
	cashEquity?: number;
}
export type ProfileRealEstateType = keyof typeof ProfileRealEstateTypeMap;

export const ProfileRealEstateTypeMap = {
	None: 'Select a Real Estate Type',
	Office: 'Office',
	MedicalOffice: 'Medical Office',
	Childcare: 'Childcare',
	Retail: 'Retail',
	SelfStorage: 'Self Storage',
	Industrial: 'Industrial',
	IndustrialManufacturing: 'Industrial Manufacturing',
	IndustrialFlexHybrid: 'Industrial Flex/Hybrid',
	IndustrialDistribution: 'Industrial Distribution',
	IndustrialWarehouse: 'Industrial Warehouse',
	Hospitality: 'Hospitality',
	ResidentialHealthcare: 'Residential Healthcare',
	Multifamily: 'Multifamily',
	InvestorOwedResidential: 'Investor Owned Residential',
};
